import { ClientOffice } from '@core/models/client.models';
import { EntityState } from '@ngrx/entity';

export interface OfficesState extends EntityState<ClientOffice> {
  isLoaded: boolean;
  isLoading: boolean;
  selected: string;
}
